import type {
    AdminServiceUnsupportedBillingError,
    CollectUnsupportedAdminServiceBillingParams,
} from '../types';

const collectUnsupportedAdminServiceBilling = ({
    caughtError,
}: CollectUnsupportedAdminServiceBillingParams): AdminServiceUnsupportedBillingError => {
    const maybeUnsupported = caughtError as AdminServiceUnsupportedBillingError;
    if (maybeUnsupported.code === 'SERVICE_BILLING_UNSUPPORTED') {
        return maybeUnsupported;
    }
    throw caughtError;
};

export default collectUnsupportedAdminServiceBilling;
